// extracted by mini-css-extract-plugin
export default {"hero":"Dashboard_hero__4k0Pa","heroContent":"Dashboard_heroContent__7Z6+6","greeting":"Dashboard_greeting__uyR+X"};